module.exports = __webpack_public_path__ + "img/goal-percent2.c159d2a5.png";